import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { GoogleMap } from '@angular/google-maps';

@Component({
  selector: 'app-map',
  template: `
    <input
      type="text"
      class="pac-controls"
      (keydown.enter)="$event.preventDefault()"
      placeholder="Search Location"
      [hidden]="viewMode"
      #search
    />
    <google-map
      #myGoogleMap
      height="400px"
      width="100%"
      [zoom]="geoZoom"
      [center]="center"
      [options]="options"
      (mapClick)="eventHandler($event, 'mapClick')"
      (mapMousemove)="eventHandler($event, 'mapMouseMove')"
    >
      <map-marker
        *ngFor="let marker of markers"
        [position]="marker.position"
        [options]="marker.options"
      >
      </map-marker>
    </google-map>

    <div style="font-size: 11px; color: #777">
      {{ 'LATITUDE' | translate }}: <span #mapLatLabel></span> / {{ 'LONGITUDE' | translate }}:
      <span #mapLngLabel></span> / {{ 'ZOOM' | translate }}: <span #mapZoomLabel></span>
    </div>
  `,
})
export class MapComponent implements OnInit {
  @Input() lat: string;
  @Input() lng: string;
  @Input() zoom: string;
  @Input() viewMode: boolean;
  @Output() private selectedMapPlace = new EventEmitter();
  // { lat: number; lng: number, zoom: number }

  geoLat: number;
  geoLng: number;
  geoZoom: number;

  googleMapLoaded = true;

  @ViewChild('search') searchField: ElementRef;
  @ViewChild(GoogleMap) map: GoogleMap;

  @ViewChild('mapLatLabel') mapLatLabel: ElementRef;
  @ViewChild('mapLngLabel') mapLngLabel: ElementRef;
  @ViewChild('mapZoomLabel') mapZoomLabel: ElementRef;

  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    zoomControl: true,
    scrollwheel: false,
    // disableDefaultUI: true,
    fullscreenControl: true,
    disableDoubleClickZoom: true,
    mapTypeId: 'roadmap', // hybrid
    maxZoom: 20,
    minZoom: 5,
  };

  markers = [];

  constructor() {}

  ngOnInit(): void {
    this.geoLat = this.lat ? parseFloat(this.lat) : 9.96271896977588;
    this.geoLng = this.lat ? parseFloat(this.lng) : -84.1387939453125;
    this.geoZoom = this.zoom ? parseFloat(this.zoom) : 4;

    this.center = {
      lat: this.geoLat,
      lng: this.geoLng,
    };

    if (this.lat) {
      this.addMarker(this.geoLat, this.geoLng);
    }
  }

  ngAfterViewInit(): void {
    // Binding search input control
    const searchBox = new google.maps.places.SearchBox(this.searchField.nativeElement);

    // Align search box to center
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.searchField.nativeElement);

    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();

      if (places.length === 0) return;

      const bounds = new google.maps.LatLngBounds();

      places.forEach((place) => {
        //verify result
        if (!place.geometry || !place.geometry) {
          return;
        }

        // Add markers to search
        /*const image = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        };

        // Create a marker for each place.
        const markerPlace = new google.maps.Marker({
          map: this.map,
          icon: image,
          title: place.name,
          position: place.geometry.location,
        });

        document.getElementById('geo_lat')['value'].value = this.map
          .getBounds()
          .getNorthEast()
          .lat();
        document.getElementById('geo_lng')['value'].value = this.map
          .getBounds()
          .getNorthEast()
          .lng();
        document.getElementById('geo_zoom')['value'].value = searchZoom;

        this.markers.push(markerPlace);
        */
        //
        if (place.geometry.viewport) {
          // Only geocodes have viewport
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });

      this.map.fitBounds(bounds);
    });
  }

  eventHandler(event: any, name: string) {
    if (name === 'mapClick' && !this.viewMode) {
      this.deleteMarkers();
      this.addMarker(event.latLng.lat(), event.latLng.lng());

      this.selectedMapPlace.emit({
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
        zoom: this.map.getZoom(),
      });
    } else if (name === 'mapMouseMove') {
      this.mapLatLabel.nativeElement.innerHTML = event.latLng.lat();
      this.mapLngLabel.nativeElement.innerHTML = event.latLng.lng();
      this.mapZoomLabel.nativeElement.innerHTML = this.map.getZoom();
    }
  }

  private addMarker(lat, lng) {
    this.markers.push({
      position: {
        lat: lat,
        lng: lng,
      },
      options: {
        animation: google.maps.Animation.DROP,
      },
    });
  }

  // Deletes all markers in the array by removing references to them
  private deleteMarkers() {
    this.markers = [];
  }
}

// Clear out the old markers.
// this.markers.forEach((marker) => {
//   marker = this.markers[i];
//   marker.setMap(null);
// }
// this.markers = [];

// For each place, get the icon, place name, and location.
// const searchZoom = '11';

// this.map.setZoom(searchZoom);
// map.setCenter(center); //Gives me an error

// const lat = this.geoLat;
// const lng = this.geoLng;

// const position = new google.maps.LatLng(lat, lng);
// this.addMarker(position);

// label: {
//   color: 'blue',
//   text: 'Marker label ' + (this.markers.length + 1),
// },
// title: 'Marker title ' + (this.markers.length + 1),
// info: 'Marker info ' + (this.markers.length + 1),

// const markerOptions = {
//   position: position,
//   map: this.map,
//   icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
// };

// const marker = new google.maps.Marker(markerOptions);
// this.markers.push(marker);

// this.clearMarkers();
// Removes the markers from the map, but keeps them in the array
// private clearMarkers() {
//   this.markers.forEach((marker) => {
//     marker.setMap(null);
//   });
// }

// import { GoogleMapService } from '../services/google-map.service';
// private googleMapService: GoogleMapService

// declare var google: any;

// this.googleMapService.loadGoogleMapScript().then(() => {
// this.googleMapLoaded = true;
//   this.geoLat = this.lat ? parseFloat(this.lat) : 9.96271896977588;
//   this.geoLng = this.lat ? parseFloat(this.lng) : -84.1387939453125;
//   this.geoZoom = this.zoom ? parseFloat(this.zoom) : 4;
// });

// this.geoLat = 9.96271896977588;
// this.geoLng = -84.1387939453125;
// this.geoZoom = this.zoom ? parseFloat(this.zoom) : 4;
// this.center = {
// lat: this.geoLat,
// lng: this.geoLng,
// };
// Add currrent marker
// if (this.lat) {
//   const lat = 9.96271896977588; // parseFloat(this.lat);
//   const lng = -84.1387939453125; // parseFloat(this.lng);
//   const coordinates = new google.maps.LatLng(lat, lng);
//   this.addMarker(this.map, coordinates);
// }
